<div class="content-with-filled-button">
    <main class="field col-4 col-pr-12 col-sm-8 col-md-12 col-lg-12 col-xl-12 px-0">
        <h2 class="title offset-inline" id="generalTitle">
            {{copyService.copies.amount_request_title}} {{copyService.copies.amount_request_title_two}}
        </h2>
        <h3 class="sub-title offset-inline" id="subgeneralTitle">
            {{copyService.copies.amount_request_subTitle}}
        </h3>
        <div class="content">
            <form class="form row" id="amountValueForm" [formGroup]="formGroup">
                <div class="field col-4 col-pr-12 col-sm-4 col-md-4 col-lg-4 col-xl-4 mt-3">
                    <vcl-form-field class="form" [label]="copyService.copies.amount_request_label" msgErr="{{ copyService.copies.amount_request_error }}">
                        <input vclInput id="inputAmountValue" voxelMask="currency" [config]="config"
                        placeholder="{{copyService.copies.amount_request_place_holder}}"
                        (focus)="reactiveOnFocus()"
                        [value]="amount" (input)="reactiveInputChangeAmount()" formControlName="amountValue" >
                    </vcl-form-field>
                    <span class="info" id="generalSpan">{{ copyService.copies.amount_request_range }}</span>
                </div>
            </form>
        </div>
    </main>
</div>
<app-controls [hasPrevious]="true" [nextLabel]="copyService.copies.amount_request_code_button" [nextDisabled]="!formGroup.valid" (next)="next()"></app-controls>
